/*/////////////////////////////////////////////////*/
import React from "react";
import { vaultServices } from "../../libs/VaultServices";
import QrReader from 'react-qr-reader';

/* Design assets */
import './codescan.css';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import LockOpen from '@material-ui/icons/LockOpen';
import Close from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import ReplayIcon from '@material-ui/icons/Replay';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

/* for dialog output */
import ArrowForward from '@material-ui/icons/ArrowForward';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';

/* DIALOG ASSET SETUP */
const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing.unit * 2,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit ,
    color: theme.palette.grey[500],
  },
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="body2">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
          <Close />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);


/* END */
/* for the aimAssist */

// const aimAssist = {
//   position: 'absolute',
//   margin: 'auto',
//   top: '0',
//   right: '0',
//   bottom: '0',
//   left: '0',
//   width: '200px',
//   height: '200px',
//   borderRadius: '3px',
//   border: '4px dashed #ddd',
//   zIndex: 2,
// }
/* END */

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
    opacity: 0.9,
    width: '90%'
  }),
  button: {
    margin: theme.spacing.unit + 15,
    // background: 'linear-gradient(45deg, #90CAF9 20%, #BBDEFB 90%)',
    backgroundColor: '#f44336',
    border: '1px solid black',
    fontSize: 16,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,     
  },
  textFieldInput: {
    fontSize: 16,
    },
  textFieldFormLabel: {
    fontSize: 16,
    paddingBottom: 2,
    marginRight: 0,
    color: "red",    
  },
  placeholder: {
    height: 40
  },
  geo: {    
    fontSize: 14,
    marginLeft: theme.spacing.unit * 5,    
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
  numericCode: {
    fontSize: 20,
    marginLeft: theme.spacing.unit * 2
  },
  reloadButton: {
    float: 'right',    
    // color: 'red',
    marginTop: theme.spacing.unit,
    padding: 0
  },
 
});
/* ======================================================================================== */
/* Design assets end */
/* ======================================================================================== */
class CodeScan extends React.Component {
  constructor (props) {
    super(props)

    this.state = {   
      userId: "",
      token: "",
      loading: false,
      error: null,
      errorInfo: null,
      disabled: false,
      open: false,
      vaultId: "",
      result: "",
      delay: 100,
      bgColor: "",      
      cme: "",
      pulser: false,
      tempCodeJustification: null
    }
    this.handleScan = this.handleScan.bind(this);    
  }

  componentDidMount() {
    let user = sessionStorage.getItem("user");
      if (user) {
       // console.log(user);
        let x = JSON.parse(user);
        this.setState(() => ({
          userId: x.userId,
          token: x.token,
          orgId: x.orgId
        }));
      }          
  }

  handleClose = () => {
    this.setState({ open: false });
    this.props.history.push('/');
  };

  handleScan(data){
    if(data) {
      this.setState({
        result: data,
        bgColor: '#42f453',        
        cme: "hidden",
        pulser: "visible",
      })
      this.onData();
    };
  };
 
  handleError = () => {
    let isError = false;
    
    if (this.state.result < 2) {
      isError = true;
      this.setState({
          error : "Invalid Vault Id"
      });
    }    
    return isError;
  };

  reloadMe = () => {
    this.setState({result:null,bgColor:""});
    
  };

  onData = async () => {    
    
    let tempCodeJustify = 'Vault scanned by user';
    const separator = ':';
    const err = this.handleError();
    this.setState({vaultIdError:""});
    const e = "error";

    if (!err) {
      try {
        this.setState({ loading: true });
        this.setState({vaultId: this.state.result.split(separator).shift(), tempCodeJustification: tempCodeJustify}) 

        let vaultData = await vaultServices.fetchTempAccessCode(this.state.userId, this.state.vaultId, this.state.token, this.state.orgId, this.state.tempCodeJustification, 1);

        if (vaultData.data.tempCode) {
          this.setState({vaultData: vaultData});        
          this.setState({open: true});    
          if(this.state.vaultIdError.length > 0){
            this.setState({vaultIdError:""});
          }           
          this.setState({loading: false});
          this.setState({pulser: "hidden"});
        } else {
          throw(e);
        }
      } catch (e) {
        //alert(e);        
        this.setState({vaultIdError: 'Invalid Vault Id. Please try again'});        
        this.setState({loading: false});          
        this.setState({open: false});
        this.setState({pulser: "hidden"});
        this.setState({bgColor: "#f44336"})
      }
    }
  };

  getArrows = (theVal) => {
  
    var s = theVal.split('');
      for (var i = 0; i < s.length; i++) {
          switch(s[i]) {
              case 'R':            
              s[i] = "R";
              break;
          case 'L':     
              s[i] = "L";
              break;
          case 'U':
              s[i] = "U";
              break;
          case 'D':
              s[i] = "D";
              break;
          default:
              break;
          }      
      }
      var x = s.join('');
      var result = this.flatMap(x, function (part) {
        return [part];
      });
  
      return result ;
  }
  flatMap(array, fn) {
    var result = [];
    for (var i = 0; i < array.length; i++) {
      var mapping = fn(array[i]);
      result = result.concat(mapping);
    }
    return result;
  }

  renderTempCode() {
        
    //quick verify
    /*let justification = this.state.tempCodeJustification.replace(/^\s+|\s+$/gm,'');
    
    if (justification.length === 0) {           
        this.setState({ tempCodeJustificationError: "ERROR",
                        dirty: false,
                        displayDialogTempCodeReason: true});
        return false
    }*/
    //fetch data - ferret out the arrows - output the results//
    let details = Object.assign({}, this.state.vaultData.data); 
    let classes = this.props;
    let arr = this.getArrows(details.tempCode);
    
    let y = arr.map(code => (
            <div className="codes">
              {code === 'R' ?
              (<ArrowForward />)
              : code === 'L' ?
              (<ArrowBack  />)
              : code === 'U' ?
                (<ArrowUpward  />)
              : code === 'D' ?         
                (<ArrowDownward />)
              : <span className={classes.numericCode}>{code}</span>
              }
            </div>            
    )); 
    return y;            
  }
/* ======================================================================================== */  
  render() {   
    const { classes } = this.props; 
    const { pulser } = this.state; 
    const { vaultData } = this.state;
    
/* ======================================================================================== */
    return (  
      
      <div className="wrapper">
       
      <Paper className={classes.root} style={{backgroundColor: this.state.bgColor}}>            
      
     
      
        {this.state.result ?
        (
            <Paper className={classes.root}>
              <CircularProgress style={{float:"right",visibility: pulser}} />
            
              {this.state.result &&
              (
                <Typography variant="body2">
                  
                  {this.state.vaultIdError !== "" &&
                    <div>
                    <FormHelperText id="vault-error-text" className={classes.textFieldFormLabel}>{this.state.vaultIdError}</FormHelperText>
                    <IconButton aria-label="Replay" onClick={this.reloadMe} className={classes.reloadButton}><ReplayIcon fontSize="medium" /></IconButton> 
                    </div>
                  }
                  
                  <LockOpen className={classes.leftIcon} />Your vault : {this.state.vaultId}
                </Typography>
                /* <audio src={mwspiAlert} autoPlay /> */                 
              )}            
            </Paper>          
        )      
        :
        (           
          <div>
          {/* <div style={aimAssist}></div> */}
          <QrReader
            delay={this.state.delay}
            facingMode={"environment"}
            style={{ width: '100%', height: "100%", objectFit: "fill", padding: '0',zIndex: 1}}
            onError={this.handleError}
            onScan={this.handleScan}                            
          />          
          </div>
               
        )} 
      <Dialog
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={this.state.open}>         
        <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
          <LockOpen className={classes.leftIcon} />Your Temp Code
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2">                                           
            {vaultData ?
              ( 
                <Typography variant="body3" gutterBottom>
                  {vaultData ?
                    (<React.Fragment>{this.renderTempCode()}</React.Fragment>)
                    : ""
                  }
                </Typography>
              )
            : ""
            }
            </Typography>
        </DialogContent>
      </Dialog>
      </Paper>      
      </div>        
    );
  }
}
export default withStyles(styles)(CodeScan);


// WEBPACK FOOTER //
// ./src/containers/CodeScan/codescan.js